import { useState, useEffect } from "react";

export interface Breakpoint {
  isMobile: boolean;
  isCompact: boolean;
}

/* Window-size hook used by AppShell and the sim panes to switch between
   the desktop three-pane layout and the mobile tabbed layout. */
export function useBreakpoint(): Breakpoint {
  const get = (): Breakpoint => ({
    isMobile: typeof window !== "undefined" && window.innerWidth < 768,
    isCompact: typeof window !== "undefined" && window.innerWidth < 1024,
  });
  const [b, setB] = useState<Breakpoint>(
    typeof window !== "undefined" ? get() : { isMobile: false, isCompact: false },
  );
  useEffect(() => {
    const f = (): void => setB(get());
    window.addEventListener("resize", f);
    return () => window.removeEventListener("resize", f);
  }, []);
  return b;
}
